import store from '@/store'

export default [
  {
    path: '/payment-testing',
    name: 'payment-test',
    meta: { requiresAuth: true },
    component: () => import('@/pages/payment-testing/index.vue')
  },
  {
    path: '/payment-testing/create',
    name: 'payment-test-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/payment-testing/create.vue')
  },
  {
    path: '/payment-testing/:id/edit',
    name: 'payment-test-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/payment-testing/edit.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('paymentTesting/find', to.params.id)
      next()
    }
  }
]
